var _circle, _path, _path2, _path3, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#E7F5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 41.7568H17C15.8954 41.7568 15 40.8614 15 39.7568V22.7188C15 21.6142 15.8954 20.7188 17 20.7188H29.5629H48C49.1046 20.7188 50 21.6142 50 22.7188V39.7568C50 40.8614 49.1046 41.7568 48 41.7568Z",
    fill: "#59BA6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5711 19.7832L18.5474 19.801C17.8411 20.3326 17.4712 21.2 17.5768 22.0776L19.915 41.5283L49.7506 38.3924L47.4094 18.9166C47.3053 18.0506 46.761 17.3 45.9703 16.9319L45.9204 16.9087C45.107 16.53 44.151 16.6305 43.4341 17.17C42.7172 17.7095 41.7612 17.81 40.9478 17.4313C40.1344 17.0526 39.1784 17.1531 38.4615 17.6926C37.7446 18.2322 36.7886 18.3326 35.9752 17.954C35.1618 17.5753 34.2058 17.6757 33.4889 18.2153C32.772 18.7548 31.816 18.8553 31.0026 18.4766C30.1891 18.0979 29.2332 18.1984 28.5163 18.7379C27.7993 19.2775 26.8434 19.3779 26.03 18.9992C25.2165 18.6205 24.2606 18.721 23.5437 19.2606C22.8267 19.8001 21.8708 19.9006 21.0574 19.5219C20.2439 19.1432 19.288 19.2437 18.5711 19.7832Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 49.2479H48C49.1046 49.2479 50 48.3525 50 47.2479V27.2098H26.1747C25.8153 27.2098 25.4835 27.017 25.3057 26.7046L23.6054 23.7188H17C15.8954 23.7188 15 24.6142 15 25.7188V47.2479C15 48.3525 15.8954 49.2479 17 49.2479Z",
    fill: "#9FD5A8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.75,
    y: 32,
    width: 2.5,
    height: 7,
    fill: "white",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.75,
    y: 40.5,
    width: 2.5,
    height: 2.5,
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTable);
export default __webpack_public_path__ + "static/media/empty-table.2fd0f2996eeaf728e273bb427744b336.svg";
export { ForwardRef as ReactComponent };